module.exports = __webpack_public_path__ + "img/icon_tab_04_w.0b0b97c4.svg";